import { render, staticRenderFns } from "./DialogMoveCategory.vue?vue&type=template&id=615f2007&scoped=true"
import script from "./DialogMoveCategory.vue?vue&type=script&lang=js"
export * from "./DialogMoveCategory.vue?vue&type=script&lang=js"
import style0 from "./DialogMoveCategory.vue?vue&type=style&index=0&id=615f2007&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615f2007",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('615f2007')) {
      api.createRecord('615f2007', component.options)
    } else {
      api.reload('615f2007', component.options)
    }
    module.hot.accept("./DialogMoveCategory.vue?vue&type=template&id=615f2007&scoped=true", function () {
      api.rerender('615f2007', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogMoveCategory.vue"
export default component.exports